module.exports = __webpack_public_path__ + "img/banner-m.6f00844.webp";